const observer = new MutationObserver(() => {
    const noteContainer = document.querySelector('.special-instructions-label');
    if (noteContainer) {
      console.log('Element found, clicking now');
      noteContainer.click();
      observer.disconnect(); 
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

function handleCartEvents(event) {
  if (!document.querySelector('.opus-extra-image')) {
    document.querySelector('.opus-btn-checkout').insertAdjacentHTML(
      "afterend",
      `
      <div class="opus-extra-image" style="width: 100%; display: flex; justify-content: center;">
        <img src="https://cdn.shopify.com/s/files/1/0750/2954/5256/files/trustpilot_design_600.png?v=1742932933" alt="Extra Image" style="max-width: 350px; height: auto;">
      </div>`
    );
  }
}

window.addEventListener('OpusCartChange', handleCartEvents);
window.addEventListener('OpusOpenCartState', handleCartEvents);